// OTel RUM - DEVE ser o primeiro import
// import './otel/instrumentation'; // DESABILITADO TEMPORARIAMENTE

import React from 'react';
import { createRoot } from 'react-dom/client';
import clarity from '@microsoft/clarity';
import App from './App.tsx';
import './index.css';

// Inicializar Microsoft Clarity
clarity.init("vlvvonr4gr");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);